<template>
    <transition appear enter-active-class="animated bounceInRight">
        <f7-view main>
            <f7-page>
                <!-- header -->
                <cm-navbar :title="$ml.get('supplimentOrder')">
                    <!-- <f7-nav-right><f7-link @click="addCommonSuppliment">{{ $ml.get('save') }}</f7-link></f7-nav-right> -->
                </cm-navbar>

                <!-- body -->
                <f7-list inline-labels no-hairlines-md>
                    <f7-list-item :title="$ml.get('addCommonSuppliment')" @click="showPopup(null, null)">
                        <i class="f7-icons" slot="media">add</i>
                    </f7-list-item>
                </f7-list>

                <f7-block-title>{{ $ml.get('transferOrders') }}</f7-block-title>
                <f7-list media-list>
                    <f7-list-item v-for="(item, index) in tos" :key="index"
                        link="#"
                        @click="showPopup($helper.numFormat(item.from_amount - item.to_amount), item.id)"
                        :title="'#' + item.id"
                        :after="item.created_at"
                        :subtitle="$ml.get('miss') + ': ' + ($helper.numFormat(item.from_amount - item.to_amount))"
                        :text="$ml.get('transferFrom') + ': ' + item.fmaterial.name + ' → ' + item.tmaterial.name"
                    ></f7-list-item>
                </f7-list>
                <!-- END body -->

                <f7-popup class="demo-popup" :opened="popupOpened" @popup:closed="closePopup">
                    <f7-view>
                        <f7-page>
                            <f7-navbar :title="$ml.get('suppliment')">
                                <f7-nav-right>
                                    <f7-link popup-close>{{ $ml.get('close') }}</f7-link>
                                </f7-nav-right>
                            </f7-navbar>

                            <f7-block-title v-if="this.totalMiss">{{ $ml.get('totalMiss') }}: {{ this.totalMiss }}</f7-block-title>

                            <div v-for="(item, index) in suppliments" :key="index">
                                <f7-block-title v-show="index > 0"><f7-link @click="remove(index)"><i class="f7-icons">delete</i></f7-link></f7-block-title>

                                <f7-list inline-labels no-hairlines-md>
                                    <!-- material -->
                                    <f7-list-item :title="$ml.get('material')" smart-select :smart-select-params="{openIn: 'page', closeOnSelect: true, searchbar: true}">
                                        <select @change="changeMaterial(index, item.material_id)" :name="'material_id' + item.material_id" v-model="item.material_id" v-validate="'required'">
                                            <option v-for="material in materials" :value="material.id" :key="material.id">[{{ material.materialtype.name }}] {{ material.name }}</option>
                                        </select>
                                    </f7-list-item>
                                    <!-- containers -->
                                    <f7-list-item :title="$ml.get('containers')" smart-select :smart-select-params="{openIn: 'page', searchbar: true}">
                                        <select name="container_id" multiple v-model="item.container_id" v-validate="'required'">
                                            <optgroup v-for="type in item.containers" :key="type.id" :label="type.name">
                                                <option v-for="container in type.containers" :key="container.id" :value="container.id">{{ container.name }} ({{ $ml.get('space') }}: {{ $helper.numFormat(container.max_capacity - container.capacity) }})</option>
                                            </optgroup>
                                        </select>
                                    </f7-list-item>
                                    <f7-list-item :title="$ml.get('bin')" smart-select :smart-select-params="{openIn: 'page', closeOnSelect: true, searchbar: true}">
                                        <select name="bin" v-model="item.bin">
                                            <option v-for="bin in $constant.bins" :value="bin" :key="bin">{{ bin }}</option>
                                        </select>
                                    </f7-list-item>
                                    <!-- amount -->
                                    <f7-list-input type="number" :label="$ml.get('amount')" placeholder="0" clear-button :value="item.amount" @input="item.amount = $event.target.value" :name="'amount' + item.id" v-validate="'required'"></f7-list-input>
                                </f7-list>
                            </div>

                            <f7-block>
                                <f7-row>
                                    <f7-col>
                                        <f7-button round fill @click="addMore">
                                            <i class="f7-icons">add</i>
                                        </f7-button>
                                    </f7-col>
                                    <f7-col>
                                        <f7-button round fill @click="submitSuppliment">
                                            <i class="f7-icons" style="font-size: 24px; line-height: inherit">save</i>
                                        </f7-button>
                                    </f7-col>
                                </f7-row>
                            </f7-block>
                        </f7-page>
                    </f7-view>
                </f7-popup>
            </f7-page>
        </f7-view>
    </transition>
</template>

<script>
    import CMNavbar from './Navbar'
    import Query    from '@/services/api/Query'
    import Mutation from '@/services/api/Mutation'

    export default {
        name: 'CheckFormula',
        components: {
            'cm-navbar': CMNavbar,
        },
        data() {
            return {
                tos: [],
                materials: [],
                totalMiss: null,
                toId: null,
                popupOpened: false,
                suppliments: [
                    {
                        'bin': null,
                        'amount': null,
                        'material_id': null,
                        'container_id': [],
                        'containers': [],
                    },
                ],
                form: {
                    amount: null,
                    material_id: null,
                    container_id: [],
                },
                containers: [],
            }
        },
        methods: {

            async reset() {
                this.$helper.clearAll()
                this.popupOpened = false
                let formData = await Query
                    .withTos(false)
                    .withMaterials('LNLPP')
                    .get()

                this.tos         = this.$helper.data(formData, 'tos')
                this.materials   = this.$helper.data(formData, 'materials')
                this.suppliments = [
                    {
                        'bin': null,
                        'amount': null,
                        'material_id': null,
                        'container_id': [],
                        'containers': [],
                    },
                ]
            },

            async getContainers(material_id = 0) {
                let result      = await Query.withContainersByType({'material_id': material_id, 'strict': null}).get()
                this.containers = this.$helper.data(result, 'container_by_type')
            },

            async changeMaterial(index, material_id) {
                let data = await Query.withContainersByType({'material_id': material_id, 'strict': null}).get()
                this.suppliments[index].containers = this.$helper.data(data, 'container_by_type')
            },

            async submitSuppliment() {
                if (! await this.$validator.validateAll())
                    return this.$f7.dialog.alert(this.$ml.get('errors.requiredAll'), this.$ml.get('errors.title'))

                this.$f7.dialog.preloader(this.$ml.get('processing'))
                let result = null;
                if (this.toId) {
                    let params = {
                        'id': this.toId,
                        'data': this.$helper.toString(this.suppliments.map((item) => {
                            return {
                                'bin': item.bin,
                                'amount': item.amount,
                                'material_id': item.material_id,
                                'container_id': item.container_id,
                            };
                        }))
                    }
                    result = await Mutation.addSuppliment(params).execute()
                } else {
                    result = await Mutation.addCommonSuppliment(this.$helper.toString(this.suppliments.map((item) => {
                        return {
                            'bin': item.bin,
                            'amount': item.amount,
                            'material_id': item.material_id,
                            'container_id': item.container_id,
                        };
                    }))).execute()
                }

                if (result.data.errors) {
                    this.$f7.dialog.close()
                    let message = this.$helper.errors(result.data.errors)

                    return this.$f7.dialog.alert(message, this.$ml.get('errors.title'))
                }

                this.$f7.dialog.close()
                return this.$f7.dialog.alert(
                    this.$ml.get('success.addSuppliment'),
                    this.$ml.get('information'),
                    async () => await this.reset()
                )
            },

            remove(index) {
                this.suppliments.splice(index, 1)
            },

            closePopup() {
                this.popupOpened = false
            },

            showPopup(totalMiss = null, toId = null) {
                this.toId        = toId
                this.totalMiss   = totalMiss
                this.popupOpened = true
            },

            addMore() {
                this.suppliments.push({
                    'bin': null,
                    'amount': null,
                    'material_id': null,
                    'container_id': [],
                    'containers': [],
                })
            },

        },

        async created() {
            await this.reset()
        },

        watch: {
            'form.material_id' (val) {
                this.getContainers(val)
            },
        },
    }
</script>